import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ArrowLeft } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Tracking.module.scss';
import SignUp from './SignUp';
import Tracker from './Tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";

var Tracking = function Tracking(_ref) {
  var bopis = _ref.bopis,
      cancelled = _ref.cancelled,
      cancelledAt = _ref.cancelledAt,
      fulfillmentStatus = _ref.fulfillmentStatus,
      loading = _ref.loading,
      trackers = _ref.trackers,
      transactions = _ref.transactions;
  return /*#__PURE__*/_jsx("div", {
    className: css.root,
    children: /*#__PURE__*/_jsxs("section", {
      className: css.main,
      children: [/*#__PURE__*/_jsxs("a", {
        className: cc([css.arrowLink, css.left]),
        href: "/account",
        children: [/*#__PURE__*/_jsx(ArrowLeft, {}), "Back to Your Orders"]
      }), trackers.map(function (tracker, idx) {
        return /*#__PURE__*/_createElement(Tracker, _objectSpread(_objectSpread({}, tracker), {}, {
          bopis: bopis,
          cancelled: cancelled,
          cancelledAt: cancelledAt,
          fulfillmentStatus: fulfillmentStatus,
          loading: loading,
          key: idx,
          transactions: transactions
        }));
      }), /*#__PURE__*/_jsx(SignUp, {})]
    })
  });
};

Tracking.defaultProps = {
  cancelled: false,
  cancelledAt: false,
  transactions: false
};
Tracking.propTypes = {
  bopis: PropTypes.bool,
  cancelled: PropTypes.bool,
  cancelledAt: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  fulfillmentStatus: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  trackers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  transactions: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.shape())])
};
export default Tracking;